"use client";

import Image from "next/image";
import { sendGAEvent } from "@next/third-parties/google";

const Sponsor = () => {
  const handleSponsorClick = () => {
    sendGAEvent({
      event: "sponsor_click",
      event_category: "engagement",
      event_label: "headshotgrapher_sponsor",
      value: 1,
    });
  };

  return (
    <div className="my-2 mb-3 flex w-full justify-center">
      <a
        href="https://headshotgrapher.com?utm_source=moaijobs&utm_medium=referral&utm_campaign=moaijobs_sponsor"
        className="group block w-full overflow-hidden rounded-md border border-orange-200 bg-orange-50 transition-all duration-300 lg:w-[75%] xl:w-[60%]"
        onClick={handleSponsorClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="relative p-4">
          <div className="relative z-10 flex flex-col sm:flex-row items-end sm:items-center gap-2">
            <div className="flex flex-row gap-2 items-center">
            {/* Profile image with glowing effect - always on the left */}
            <div className="relative flex-shrink-0">
              <div className="absolute inset-0 rounded-full bg-gray-400 opacity-30 blur-md transition-opacity group-hover:opacity-50"></div>
              <Image
                src="/sam_1.png"
                alt="Professional headshot"
                width={120}
                height={120}
                className="relative h-16 w-16 rounded-full border-2 border-white/30"
              />
            </div>

            {/* Content and button in a compact layout */}
            <div className="flex min-w-0 flex-grow flex-col">
              {/* Title row with badge */}
              <div className="flex flex-row items-center gap-x-2 gap-y-1">
                <h3 className="text-base leading-tight font-bold md:text-lg mb-1.5">
                  Upgrade Your Profile With Professional Headshots
                </h3>
                {/* <span className="inline-block bg-orange-500/30 rounded-md border border-orange-400/30 px-2 py-0.5 text-xs font-semibold whitespace-nowrap">3x Results</span> */}
              </div>

              {/* Description and CTA in a row on mobile and larger */}
              <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
                <p className="line-clamp-3 text-xs md:text-sm">
                  Stand out in the AI job market. Upload 6–7 photos and get
                  high-quality headshots in 3 minutes using AI.
                </p>
              </div>
            </div>

            </div>

            {/* CTA Button - more compact on mobile */}
            <div className="flex flex-shrink-0 items-center gap-2 w-full sm:w-auto">
              <p className="hidden text-xs text-gray-400 sm:block">Ad</p>
              <div className="btn btn-primary w-full flex items-center gap-1 rounded-md border-0 bg-orange-500 px-3 py-1 text-xs font-medium whitespace-nowrap shadow-md transition-all group-hover:gap-2 md:px-4 md:py-2 md:text-sm">
                Get Your Headshots
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3 transition-transform group-hover:translate-x-1 md:h-4 md:w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Sponsor;